import React from 'react';
import './ProPoem.css';

const ProPoem = () => {
    return (
        <div className="pro-poem-container">
            <h3>A poem I wrote in 60 seconds</h3>
            <div className="poem">
                <p>Today is a day, a day I shan't forget.</p>
                <p>Today is a day, I fell into a deep pit,</p>
                <p>and tomorrow I shall climb and leave it all behind,</p>
                <p>for the future is bright and I have seen the light</p>
                <p className="author">-Daniel Mahan</p>
            </div>
        </div>
      
    );
};

export default ProPoem;
